var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar7 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-7_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1788FB",
  d: "M60 30C60 13.432 46.569 0 30 0 13.432 0 0 13.432 0 30c0 16.569 13.432 30 30 30 16.569 0 30-13.431 30-30"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5C400",
  d: "M38.082 31.058h-.012l-16.138-.008c-.365 0-.712-.16-.95-.437L11.647 19.67a1.3 1.3 0 0 1-.217-.365 4.06 4.06 0 0 1 .46-3.802c.835-1.213 2.242-1.938 3.77-1.938h28.682c1.525 0 2.935.725 3.768 1.938a4.06 4.06 0 0 1 .462 3.8q-.06.155-.157.287c-.02.027-2.03 2.79-4.183 5.515-4.667 5.912-5.467 5.95-6.15 5.95zm-15.575-2.506 15.34.008c1.155-.78 5.183-5.822 8.433-10.282a1.58 1.58 0 0 0-.233-1.353c-.367-.535-1.007-.855-1.71-.855H15.66c-.703 0-1.34.32-1.71.855-.165.24-.4.715-.243 1.313l8.803 10.317z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5C400",
  d: "M42.005 11.45v14.453c0 6.517-5.283 11.8-11.8 11.8s-11.8-5.283-11.8-11.8V11.45a2.06 2.06 0 0 1 2.355-2.038c1.96.278 5.127.59 9.445.59 4.317 0 7.485-.312 9.445-.59a2.062 2.062 0 0 1 2.355 2.038M38.23 52.905H22.177a2 2 0 0 1-1.997-1.998V48.87a8.5 8.5 0 0 0 8.5-8.5h3.05a8.5 8.5 0 0 0 8.5 8.5v2.038a2 2 0 0 1-1.998 1.997z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2B41C",
  d: "M48.11 15.505c-.835-1.213-2.242-1.937-3.767-1.937h-2.338V11.45a2.06 2.06 0 0 0-2.355-2.038c-1.96.278-5.127.59-9.445.59v27.7c5.775 0 10.578-4.15 11.598-9.632a90 90 0 0 0 2.432-2.962 199 199 0 0 0 4.183-5.515q.097-.133.157-.288c.49-1.277.32-2.663-.462-3.8zm-1.827 2.77a172 172 0 0 1-4.278 5.623V16.07h2.338c.702 0 1.34.32 1.71.855.17.245.412.735.232 1.352zm-16.078 34.63V40.37h1.525a8.5 8.5 0 0 0 8.5 8.5v2.038a2 2 0 0 1-1.997 1.997h-8.028"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D58D43",
  d: "M42.002 16.067H18.405v3.638h23.597zM30.205 41.983a3.848 3.848 0 1 0 0-7.696 3.848 3.848 0 0 0 0 7.696"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BA7231",
  d: "M42.005 19.705h-11.8v-3.637h11.8zm-11.8 22.278a3.847 3.847 0 1 0 0-7.695v7.697z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-7_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
})))));
export { SvgAvatar7 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-7.b78fc387aec487583439.svg";